<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.consignment"
        :primary-fields="[ 'con_full', 'account', 'carrier', 'service', 'team', 'con_ref']"
        @apply="reload"
        @ready="load"
        @keyup.enter.native="$emit('apply')"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <div
          slot="header"
          class="clearfix"
        >
          <el-select
            v-model="selectedColumns"
            v-loading="isSavingPreferences"
            multiple
            collapse-tags
            style="float: right; margin-left: 20px;"
            placeholder="Columns"
            @change="columnChange"
            @visible-change="saveConfiguration"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <ConsignmentsTable
          v-if="consignments.length"
          :consignments="consignments"
          :selected-columns="selectedColumns"
        >
          <!-- <template v-slot:peek="{ consignment }">
            <ConsignmentPeek :consignment="consignment" />
          </template> -->

          <template v-slot:reference="{ consignment }">
            <router-link :to="{ name: 'freight-consignments-v3-consignment', params: { consignmentId: consignment.id } }">
              {{ consignment.con_full }}
            </router-link>
          </template>
          <!-- <template v-slot:actions="{ consignment }">
            <el-dropdown
              split-button
              size="small"
              trigger="click"
              icon="el-icon-edit"
            >
              <span v-if="consignment.edi_id > 0">
                View
              </span>
              <span v-else>
                Edit
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  icon="el-icon-tickets"
                >
                  Print
                </el-dropdown-item>

                <el-dropdown-item
                  icon="el-icon-finished"
                >
                  Manifest
                </el-dropdown-item>

                <el-dropdown-item
                  divided
                  icon="el-icon-delete"
                >
                  Delete
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template> -->
        </ConsignmentsTable>
        <Empty
          v-else
          description="No Consignments Found"
        />
        <el-pagination
          class="text-center pt-3"
          :current-page.sync="page"
          :page-size.sync="perPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="consignments.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { SET_CONFIGURATION } from '@/store/mutation-types'
import ConsignmentsTable from '@/components/Application/Freight/Consignments/Table'
import ConsignmentCreateDialog from '@/components/Application/Freight/Consignments/CreateDialog'
// import ConsignmentPeek from '@/components/Application/Freight/ConsignmentPeek'
import Filters from '@/components/Filters/Simplified'
import Filter, { IS } from '@/plugins/sdk/Filter'
import Empty from '@/components/Empty'
import Vue from 'vue'
import Request, { GET } from '@/plugins/sdk/Request'

export default {
  components: {
    ConsignmentsTable,
    Filters,
    Empty
  },
  data () {
    return {
      actions: [
        [
          {
            hidden: true,
            name: 'Create',
            icon: ['fal', 'plus'],
            event: () => {
              this.createConsignment()
            }
          },
          {
            name: 'Search Sync',
            icon: ['fal', 'search-plus'],
            event: this.reindexConsignment,
            loading: this.isReindexingConsignment
          }
          // {
          //   hidden: false,
          //   name: 'Manifest',
          //   icon: 'el-icon-finished'
          // },
          // {
          //   hidden: false,
          //   name: 'Print',
          //   icon: 'el-icon-tickets'
          // },
          // {
          //   hidden: false,
          //   name: 'Delete',
          //   icon: 'el-icon-trash'
          // }
        ],
        [
          {
            name: 'Refresh',
            icon: ['fal', 'sync'],
            event: this.reload
          }
        ]
      ],
      isLoading: true,
      isReindexingConsignment: false,
      filters: [
        new Filter('con_type', IS, 0)
      ],
      consignments: [],
      consignmentCreateDialogInstance: null,
      consignmentCreateDialogVisible: false,
      selectedColumns: [ 'con_full', 'account', 'carrier', 'service', 'team', 'con_ref' ],
      configuration: null,
      options: [
        {
          value: 'con_despatch_date',
          label: 'Despatch Date'
        },
        {
          value: 'con_manifest_date',
          label: 'Manifest Date'
        },
        {
          value: 'con_delivery_date',
          label: 'Delivery Date'
        },
        {
          value: 'con_ref',
          label: 'Reference'
        },
        {
          value: 'con_internal_ref',
          label: 'Internal Reference'
        },
        {
          value: 'con_sum_items',
          label: 'Total Items'
        },
        {
          value: 'con_sum_weight',
          label: 'Total Weight'
        },
        {
          value: 'con_sum_cube',
          label: 'Total Cube'
        },
        {
          value: 'con_sender_name',
          label: 'Sender Name'
        },
        {
          value: 'con_sender_address_1',
          label: 'Sender Address 1'
        },
        {
          value: 'con_sender_address_2',
          label: 'Sender Address 2'
        },
        {
          value: 'con_sender_town',
          label: 'Sender Town'
        },
        {
          value: 'con_sender_state',
          label: 'Sender State'
        },
        {
          value: 'con_sender_postcode',
          label: 'Sender Postcode'
        },
        {
          value: 'con_sender_contact',
          label: 'Sender Contact'
        },
        {
          value: 'con_sender_phone',
          label: 'Sender Phone'
        },
        {
          value: 'con_sender_email',
          label: 'Sender Email'
        },
        {
          value: 'con_sender_residential',
          label: 'Sender Residential'
        },
        {
          value: 'con_receiver_name',
          label: 'Receiver Name'
        },
        {
          value: 'con_receiver_address_1',
          label: 'Receiver Address 1'
        },
        {
          value: 'con_receiver_address_2',
          label: 'Receiver Address 2'
        },
        {
          value: 'con_receiver_town',
          label: 'Receiver Town'
        },
        {
          value: 'con_receiver_state',
          label: 'Receiver State'
        },
        {
          value: 'con_receiver_postcode',
          label: 'Receiver Postcode'
        },
        {
          value: 'con_receiver_contact',
          label: 'Receiver Contact'
        },
        {
          value: 'con_receiver_phone',
          label: 'Receiver Phone'
        },
        {
          value: 'con_receiver_email',
          label: 'Receiver Email'
        },
        {
          value: 'con_receiver_residential',
          label: 'Receiver Residential'
        },
        {
          value: 'con_special_instructions',
          label: 'Special Instrucitons'
        },
        {
          value: 'con_est_price',
          label: 'Est. Price'
        },
        {
          value: 'con_costcent',
          label: 'Cost Centre'
        },
        {
          value: 'con_is_dg',
          label: 'DG'
        },
        {
          value: 'authority_to_leave',
          label: 'ATL'
        },
        {
          value: 'edi_id',
          label: 'EDI'
        },
        {
          value: 'pickup',
          label: 'Pickup'
        },
        {
          value: 'carrier',
          label: 'Carrier'
        },
        {
          value: 'service',
          label: 'Service'
        },
        {
          value: 'account',
          label: 'Account'
        },
        {
          value: 'team',
          label: 'Team'
        },
        {
          value: 'zone_from',
          label: 'Zone From'
        },
        {
          value: 'zone_to',
          label: 'Zone To'
        }
      ],
      isSavingPreferences: false,
      page: 1,
      perPage: 20,
      searchAboutController: undefined
    }
  },
  created () {
    this.configuration = this.$_.cloneDeep(this.$store.getters.configuration)
    if (this.$_.isEmpty(this.configuration.consignmentTable)) {
      this.selectedColumns = [ 'account', 'carrier', 'service', 'team', 'con_ref' ]
    } else {
      this.selectedColumns = this.configuration.consignmentTable
    }
  },
  methods: {
    async reindexConsignment () {
      this.isReindexingConsignment = true
      for (const consignment of this.consignments) {
        const request = Object.assign(new Request(), {
          _pathname: `/public/search/create/TIGFRE/consignment/${consignment.id}`,
          method: GET
        })
        let res = await fetch(await request.build())
        if (res.ok) {
          this.$notify.success(`Consignment ${consignment.con_full} added to reindex queue`)
        } else {
          this.$notify.error(`Failed to add consignment ${consignment.con_full} to reindex queue`)
        }
      }
      this.$message.info('Finished adding consignments to reindex queue')
      this.isReindexingConsignment = false
    },
    createConsignment () {
      const ConsignmentCreateDialogClass = Vue.extend(ConsignmentCreateDialog)

      this.consignmentCreateDialogInstance = new ConsignmentCreateDialogClass({})

      this
        .consignmentCreateDialogInstance
        .$on('destroy', () => {
          this.consignmentCreateDialogVisible = false
        })

      this
        .consignmentCreateDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.consignmentCreateDialogInstance.$el)

      this.consignmentCreateDialogVisible = true
    },
    columnChange (value) {
      this.selectedColumns = value
    },
    async saveConfiguration (value) {
      if (!value) {
        this.isSavingPreferences = true
        this.configuration.consignmentTable = this.selectedColumns
        this.$store.commit(`configuration/${SET_CONFIGURATION}`, this.configuration)
        await this.$user.instance.saveConfiguration()
        this.$message.success('Table Preferences Saved')
        this.isSavingPreferences = false
      }
    },
    async load () {
      this.isLoading = true

      if (typeof this.searchAbortController !== 'undefined') {
        this.searchAbortController.abort()
      }

      this.searchAbortController = new AbortController()

      try {
        this.consignments = await this
          .$sdk
          .consignment
          .list(request => {
            request.filters = [
              ...this.filters
            ]
            request.include = [
              'account',
              'carrier',
              'service',
              'team',
              'pickup'
            ]
            request.order = 'con_id:desc'
            request.page = this.page
            request.limit = this.perPage
          }, this.searchAbortController.signal)
      } catch (error) {
        // console.error('error', error)
      } finally {
        this.searchAbortController = undefined
        this.isLoading = false
      }
    },
    async reload () {
      this.isLoading = true

      if (typeof this.searchAbortController !== 'undefined') {
        this.searchAbortController.abort()
      }

      this.searchAbortController = new AbortController()

      try {
        this.consignments = await this
          .$sdk
          .consignment
          .list(request => {
            request.filters = [
              ...this.filters
            ]
            request.include = [
              'account',
              'carrier',
              'service'
            ]
            request.order = 'con_id:desc'
            request.page = this.page
            request.limit = this.perPage
          }, this.searchAbortController.signal)
      } catch (error) {
        // console.error('error', error)
      } finally {
        this.searchAbortController = undefined
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-button--mini {
    border-left: 1px solid #DCDFE6;

    .el-dropdown__icon {
      font-size: 11px;
    }
  }
</style>
